import React from 'react';
import styled from '@emotion/styled';

import { mq, text, green01 } from '../../_style';

const Section = styled.section`
  & + & {
    ${mq.pc} {
      padding-top: 90px;
    }
    ${mq.sp} {
      padding-top: 60px;
    }
  }
`;
const SectionHeading = styled.h2`
  padding-bottom: 30px;
  color: ${green01};

  ${mq.pc} {
    ${text('26px', (38/26))}
  }
  ${mq.sp} {
    ${text('26px', (36/26))}
  }
`;

const ArticleSection = (props) => {
  return(
    <Section>
      {props.heading ? <SectionHeading className={props.color ? props.color : ""}>{props.heading}</SectionHeading> : ''}
      {props.children}
    </Section>
  );
};
export default ArticleSection;
